export default [
    {
        title: '密码修改',
        path: '/personal/pwd',
        name: 'personalPwd',
        component: () => import('@/views/personal/pwd'),
        meta: {
            key: 'personal'
        },
        menu: false,
        permission: false
    }
];
